export default "__VITE_ASSET__CtlgSh_5__"